import { SIDEBAR_VIEWS,  MAP_TOOLS } from '../../../lib/constants';

export default (dispatch) => ({
  beginSelectingFeatures: () => {
    dispatch({
      type: 'map/resetWidgetState',
    });

    dispatch({
      type: 'app/gotoSidebar',
      payload: SIDEBAR_VIEWS.SelectedFeatures
    });
    dispatch({
      type: 'map/enableSelectTool'
    });
    dispatch({
      type: 'map/setActiveTool',
      payload: MAP_TOOLS.Select,
    });
  },

  setSelectWidgetRef: (ref) => {
    dispatch({
      type: 'map/setSelectWidgetRef',
      payload: ref
    });
  },

  getFeaturesList: (callback) => {
    dispatch({
      type: 'features/getFeaturesList',
      callback,
    });
  },

  addSelectedFeaturesFromMap: (inPoly) => {
    dispatch({
      type: 'features/addSelectedFeaturesFromMap',
      payload: inPoly
    });
  },

  cancelWidget: () => {
    dispatch({
      type: 'map/resetWidgetState'
    });
    dispatch({
      type: 'app/gotoSidebar',
      payload: SIDEBAR_VIEWS.Content
    });
  },

});